import React from 'react';
import ConnectedMain from './containers/ConnectedMain'
import './App.css';

const App = ({store}) => {

    return (
        <div className="App">
            <ConnectedMain></ConnectedMain>
        </div>
    )

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js